import React from 'react';

const PreviewModeContext = React.createContext<{
  isPreviewMode: boolean;
  setIsPreviewMode: (mode: boolean) => void;
}>({
  isPreviewMode: false,
  setIsPreviewMode: () => {}
});

export default PreviewModeContext;
